import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetPublicTenderListMutationRequest, GetPublicTenderListMutationResponse, GetPublicTenderList400, GetPublicTenderList401, GetPublicTenderList403, GetPublicTenderList422, GetPublicTenderList429, GetPublicTenderList500 } from "../types/GetPublicTenderList";

/**
 * @link /api/purchase-tenders/private/v1/tenders/view_for-public-listing
 */

export function useGetPublicTenderList <TData = GetPublicTenderListMutationResponse, TError = GetPublicTenderList400 | GetPublicTenderList401 | GetPublicTenderList403 | GetPublicTenderList422 | GetPublicTenderList429 | GetPublicTenderList500, TVariables = GetPublicTenderListMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/private/v1/tenders/view_for-public-listing`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
